import { Clock, Users } from "lucide-react"

export const NoRecordfound = () => {
    return (
        <>
            <div className="text-center py-6 text-red-400 font-semibold">
                <Clock className="w-12 h-12 mx-auto mb-3" />
                <p>No records found</p>
            </div>
        </>
    )
}


export const NoApplicantFound = () => {
    return (
        <>
            <div className="text-center py-12">
                <Users className="w-12 h-12 mx-auto text-red-400 mb-3" />
                <p className="text-red-400 font-semibold">No applicants found</p>
                <p className="text-sm text-gray-400 font-semibold mt-1">Try adjusting your search or add new applicants</p>
            </div>
        </>
    )
}

